export const eventInfo = {
  date: '18 июня',
  address: 'Mirotel. Новосибирск, Площадь Карла Маркса, 1/1',
  ticketLabel: 'Купить билет',
  ticketHref: '/tariff'
};

export const contactGroups = [
  {
    title: 'Контакты',
    items: [
      { label: 'Организатор:', value: 'Yula Studio' },
      { label: 'Эл. почта:', value: 'org@forum-industry.ru', href: 'mailto:org@forum-industry.ru' },
      {
        label: 'Прямая связь с организатором:',
        value: 'Написать в MAX',
        href: 'https://max.ru/u/f9LHodD0cOJ1otgVx9KGa4maaCIVqQH5TX7X3JwN8a8incQQs69OylZpCCU'
      },
      {
        label: 'Канал в MAX:',
        value: '@forum-industry',
        href: 'https://max.ru/id540324189394_biz'
      }
    ]
  }
];

export const socialLinks = [];

export const legalLinks = [
  { label: 'Публичная оферта', href: '/offer' },
  { label: 'Пользовательское соглашение', href: '/agreement' },
  { label: 'Политика конфиденциальности', href: '/privacy' },
  { label: 'Нормы поведения', href: '/conduct' }
];
